import { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';

export function useTimer() {
  const [date, setDate] = useState<Moment>(moment().utc());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(moment().utc());
    }, 1 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return {
    timer: date,
  };
}
